import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { PROTECTION } from "@/pages/legal/_content";
import { ShieldCheck } from "lucide-react";

const Protection = () => (
  <LegalPage doc={PROTECTION}>
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 flex items-start gap-3">
      <ShieldCheck className="w-5 h-5 text-amber-700 mt-0.5"/>
      <div className="text-sm text-amber-900">
        <b>CarryIt Protection is not insurance.</b> It is a voluntary,
        platform-funded compensation guarantee. Read the full terms below before
        adding it to a parcel.
      </div>
    </div>
    <DocSections sections={PROTECTION.sections}/>
  </LegalPage>
);
export default Protection;
